<template>
    <div class="loader">
        <div class="spiner" />
    </div>
</template>
